import CustomBoxHeader from "../../../CommonComponents/CustomBoxHeader";
import styles from "./CompanyDetails.module.css";
import { Row, Col, Spin } from "antd";
import { useRef, useState } from "react";
import BannerEditModal from "./BannerEditModal";
import ProfileImgEditModal from "./ProfileImgEditModal";
import { GoPencil } from "react-icons/go";
import CompanyProfileImgEditModal from "./CompanyProfileImgEditModal";
import PersonalInfoEditModal from "./PersonalInfoEditModal";

const CompanyDetails = ({ data, loading, refatchData }) => {
  const divRef = useRef(null);
  const [showBannerModal, setShowBannerModal] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showProfilePicModal, setShowProfilePicModal] = useState(false);
  const [showInfoEditModal, setShowInfoEditModal] = useState(false);

  const companyInformaton = [
    {
      label: "First name",
      value: data?.firstName,
    },
    {
      label: "Last name",
      value: data?.lastName,
    },
    {
      label: "Dob",
      value: data?.dob,
    },
    {
      label: "Gender",
      value: data?.gender,
    },
    {
      label: "Email address",
      value: data?.emailAddress,
    },
    {
      label: "Phone",
      value: data?.phoneNumber,
    },
    {
      label: "Address",
      value: data?.address,
    },
    {
      label: "State/City",
      value: data?.state,
    },
    {
      label: "Country",
      value: data?.country,
    },
    {
      label: "Postcode/Zip",
      value: data?.postalCode,
    },
  ];

  const handleEdit = () => {
    setShowInfoEditModal(true);
  };

  const viewLivePage = () => {
    window.open("https://indexscore.com/enterprise-profile/" + data._id);
  };

  const handleEditBanner = () => {
    setShowBannerModal(true);
  };

  const handleEditProfile = () => {
    setShowProfileModal(true);
  };

  const handleEditPicProfile = () => {
    setShowProfilePicModal(true);
  };

  const handleSubmit = () => {
    refatchData();
  };

  return (
    <div className={styles.column_wrap}>
      {/* <Col xs={24} sm={24} md={24} lg={12} xl={12}> */}
      <div className={styles.left_col_wrap} ref={divRef}>
        <div
          className={styles.box_wrap}
          style={
            data?.companyBanner?.docs
              ? { backgroundImage: `url(${data.companyBanner.docs})` }
              : {}
          }
        >
          {loading ? (
            <div className={styles.loader_wrap}>
              <Spin />
            </div>
          ) : (
            <>
              <div className={styles.details_wrap}>
                <div>
                  <img
                    className={styles.img_wrap}
                    onClick={handleEditProfile}
                    src={data?.companyImage?.docs}
                    alt="company logo"
                  />
                </div>
                <div>
                  <div className={styles.title}>{data.companyName}</div>
                  <div className={styles.description}>{data.sector}</div>
                  <div className={styles.location}>
                    {data?.companyAddress?.country}
                  </div>
                </div>
              </div>
              <div className={styles.btn_wrap}>
                <button
                  className={styles.view_btn}
                  onClick={() => viewLivePage()}
                >
                  View live page
                </button>
                <button
                  className={styles.view_btn}
                  onClick={() => handleEditBanner()}
                >
                  Edit
                </button>
              </div>
            </>
          )}
        </div>
        <div className={styles.box_wrap_2}>
          {loading ? (
            <div className={styles.loader_wrap}>
              <Spin />
            </div>
          ) : (
            <>
              <CustomBoxHeader
                title={"Personal Information"}
                action={handleEdit}
              />
              <Row className={styles.data_wrap}>
                <Col xs={24} sm={24} md={8} lg={6} xl={5}>
                  <div className={styles.picture_label}>
                    Profile Picture <GoPencil />
                  </div>
                  <img
                    className={styles.profile_img_wrap}
                    onClick={handleEditPicProfile}
                    src={data?.companyImage?.docs}
                    alt="profile pic"
                  />
                </Col>
                <Col xs={24} sm={24} md={16} lg={18} xl={19}>
                  <Row gutter={[8, 24]}>
                    {companyInformaton.map((item) => {
                      return (
                        <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                          <div>
                            <div className={styles.label}>{item.label}</div>
                            <div className={styles.info}>{item.value}</div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            </>
          )}
        </div>
      </div>
      {/* </Col> */}
      {/* <Col xs={24} sm={12} md={24} lg={12} xl={12}>
        <div>
          <TeamMemberTable
            height={height}
            data={data?.membersData || []}
            loading={loading}
          />
        </div>
      </Col> */}
      <BannerEditModal
        isOpen={showBannerModal}
        onCancel={setShowBannerModal}
        onSubmit={handleSubmit}
      />
      <CompanyProfileImgEditModal
        isOpen={showProfileModal}
        onSubmit={handleSubmit}
        onCancel={setShowProfileModal}
      />
      <ProfileImgEditModal
        isOpen={showProfilePicModal}
        onSubmit={handleSubmit}
        onCancel={setShowProfilePicModal}
      />
      <PersonalInfoEditModal
        data={data}
        isOpen={showInfoEditModal}
        onSubmit={handleSubmit}
        onCancel={setShowInfoEditModal}
      />
    </div>
  );
};

export default CompanyDetails;
